import { init, browserTracingIntegration, replayIntegration } from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';
import { configBase } from '@/config/base';
import { isLocalHost } from '@/helpers/url';

export const setupSentry = (app: App<any>, router: Router) => {
    //Could be VITE_LOGGING_ENABLED and VITE_LOGGING_SENTRY_DSN good candidates to env variables???
    const shouldLogErrors = !(configBase.devMode.enabled || isLocalHost());
    const dataSourceName =
        'https://8e7673a2d83807a9075a7084e9c7c479@o4505316832051200.ingest.us.sentry.io/4508019398541312';

    if (shouldLogErrors) {
        init({
            app,
            dsn: dataSourceName,
            enabled: shouldLogErrors,
            integrations: [browserTracingIntegration({ router }), replayIntegration()],
            tracesSampleRate: 0.25, //  Capture 25% of the transactions
            replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
            replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        });
    }
};
